export default function AppSidebar({
  show,
  onClose,
  isAuthenticated,
  isAdmin,
  canAccessAdminConsole = false,
  sellerAccess,
  onNavigate,
  onLogout,
  onOpenSettings,
  onOpenAdmin,
}) {
  if (!show) return null;

  const sellerMenuLabel = sellerAccess?.canSellOnHobbli
    ? "Seller Dashboard"
    : "Sell on Hobbli";

  const sellerMenuDestination = sellerAccess?.canSellOnHobbli
    ? "/seller"
    : "/sell";

  return (
    <div className="sidebar-overlay" onClick={onClose}>
      <div className="sidebar" onClick={(e) => e.stopPropagation()}>
        {isAuthenticated ? (
          <>
            {(isAdmin || canAccessAdminConsole) && (
              <>
                <button onClick={onOpenAdmin}>Admin Console</button>
              </>
            )}
            <button onClick={() => onNavigate("/collection")}>My Collection</button>
            <button onClick={() => onNavigate("/orders")}>My Orders</button>
            <button onClick={() => onNavigate(sellerMenuDestination)}>{sellerMenuLabel}</button>
            <button onClick={() => onNavigate("/hub")}>Hobbli Hub</button>
            <button onClick={() => onNavigate("/social")}>Hobbli Social</button>
            <button onClick={() => onNavigate("/games")}>Game Room</button>
            <button onClick={() => onNavigate("/insights")}>Hobbli Insights</button>
            <button onClick={() => onNavigate("/shop")}>Marketplace</button>
            <button onClick={onOpenSettings}>Account Settings</button>
            <button onClick={() => onNavigate("/about")}>About & Support</button>
            <button onClick={onLogout}>Logout</button>
          </>
        ) : (
          <>
            <button onClick={() => onNavigate("/login")}>Login</button>
            <button onClick={() => onNavigate("/login", { register: true })}>
              Register
            </button>
          </>
        )}
      </div>
    </div>
  );
}
